import qs from 'qs'

const removeLeadingCharacter = (stringToCheck, leadingChar) =>
    stringToCheck.charAt(0) === leadingChar
        ? stringToCheck.substr(1)
        : stringToCheck

export const addQuerystring = (url, toStringify) => {
    if (toStringify == null) return url

    const qs = stringify(toStringify)
    return `${url}?${qs}`
}

export const addToQuerystring = (location, querystringToMerge) => {
    const { search, pathname } = location
    const currentQuerystring = parse(removeLeadingCharacter(search, '?'))

    const toStringify = {
        ...currentQuerystring,
        ...querystringToMerge,
    }

    const updatedQuerystring = stringify(toStringify)

    return updatedQuerystring ? `${pathname}?${updatedQuerystring}` : pathname
}

export const parse = toParse =>
    qs.parse(removeLeadingCharacter(toParse, '?'), { allowDots: true })

export const stringify = toStringify =>
    qs.stringify(toStringify, {
        skipNulls: true,
        encode: false,
        allowDots: true,
    })
